import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"
import {Typography} from "@mui/material"

interface StyledTextWrapperProps {
    capitalizeFirstLetter?: boolean
}

export const StyledProductTitle = styled("div")`
    padding: 0 1rem 0 1rem;
    overflow: hidden;
    grid-area: title;
    @media (max-width: ${breakpoints.values.md - 1}px) {
        padding: 0 1rem 0 1rem;
        max-width: 96vw;
    }

    // apply this styling below for ESI SEO heading h1 element
    h1,
    .esi-before-count {
        font-family: ${({theme: {colours}}) => `${colours.font.primary.medium.family}, ${colours.font.default}`};
        font-weight: ${({theme: {colours}}) => colours.font.primary.medium.weight};
        color: ${({theme: {colours}}) => colours.text.default};
        font-size: 1rem;
        letter-spacing: 0.12px;
        line-height: 1.5;
        margin: 0;
        vertical-align: bottom;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @media (min-width: ${breakpoints.values.lg}px) {
            margin: 0.4375rem 0 0 0;
        }
    }
    .esi-before-count {
        overflow: initial;
    }

    .esi-header-wrapper {
        display: flex;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-transform: capitalize;
    }

    // product count after the ESId heading
    .esi-count {
        font-family: ${({theme}) => `${theme.colours.font.primary.regular.family}, ${theme.colours.font.default}`};
        color: ${props => props.theme.colours.text.muted};
        vertical-align: bottom;
        line-height: 1.5;
        @media (min-width: ${breakpoints.values.lg}px) {
            margin: 0.4375rem 0 0 0;
        }
        // esi attempt/except doesn't work properly in dev
        // if the esi:include fails, it will leave the count on its own
        &:only-child {
            display: none;
        }

        @media (min-width: ${breakpoints.values.lg}px) {
            display: none;
        }
    }
`

export const StyledNoResultsFound = styled("span", {shouldForwardProp: prop => !String(prop).startsWith("$")})<{
    $enableCentreTitle: boolean
}>`
    font-family: ${({theme}) => `${theme.colours.font.primary.regular.family}, ${theme.colours.font.default}`};
    color: ${({theme: {colours}}) => colours.text.default};
    font-weight: ${({theme: {colours}}) => colours.font.primary.regular.weight};
    display: block;
    font-size: 0.875rem;
    line-height: 1.5;
    letter-spacing: 0.0075rem;
    text-align: ${props => (props.$enableCentreTitle ? "center" : "start")};
`

export const StyledCount = styled("span")`
    font-family: ${({theme}) => `${theme.colours.font.primary.regular.family}, ${theme.colours.font.default}`};
    color: ${props => props.theme.colours.text.muted};

    @media (min-width: ${breakpoints.values.lg}px) {
        display: none;
    }
`

export const StyledBeforeCount = styled("span")`
    font-family: ${({theme: {colours}}) => `${colours.font.primary.medium.family}, ${colours.font.default}`};
    font-weight: ${({theme: {colours}}) => colours.font.primary.medium.weight};
    color: ${({theme: {colours}}) => colours.text.default};
    font-size: 1rem;
    letter-spacing: 0.12px;
    line-height: 1.5;
    margin: auto;
    vertical-align: bottom;
    @media (min-width: ${breakpoints.values.lg}px) {
        margin: 0.4375rem 0 0 0;
    }
`

export const StyledTextWrapper = styled("span")<StyledTextWrapperProps>`
    ${({capitalizeFirstLetter}) =>
        capitalizeFirstLetter &&
        `
        &:first-letter {
            text-transform: capitalize;
        }
        `}}

    @media (min-width: ${breakpoints.values.sm}px) {
        max-width: 25rem;
    }
`

export const StyledSecondaryText = styled(Typography, {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<{$enableCentreTitle: boolean}>`
    font-size: 0.875rem;
    line-height: 1.3125rem;
    letter-spacing: 0.0075rem;
    text-align: ${props => (props.$enableCentreTitle ? "center" : "start")};
`

export const StyledCapitalizedText = styled("span")`
    text-transform: capitalize;
`

export const StyledShowingResultsForText = styled("span")`
    @media (max-width: ${breakpoints.values.sm}px) {
        display: none;
    }
`

export const CategoryWrapper = styled("div")`
    overflow: hidden;
`
export const CategoryHeading = styled("div")`
    display: flex;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: capitalize;
`
